module.exports = __webpack_public_path__ + "media/images/edools_stylized_logo-14f60c38a3e2c5a915a87e5af983752e.svg";